import './TemporaryNL.scss';

export const TemporaryNL = () => {
  return (
    <section className="temporary-nl">
      <div className="_container temporary-nl__container">
        <div className="temporary-nl__top-row">
          <img src="./nl/logo_2.webp" className="temporary-nl__logo" alt="" />
          <h1 className="temporary-nl__title">
            bijna live. nog even geduld....
          </h1>
        </div>

        <div className="temporary-nl__bottom-row">
          <p className="temporary-nl__message">
            in de tussentijd, klik hier als je ons nodig hebt
          </p>

          <a href="mailto:hallo@sixtix.nl" className="temporary-nl__contact">
            contact
          </a>
        </div>
      </div>
    </section>
  );
};
